import { createContext, useContext } from 'react';

export const AccordionContext = createContext({
  visible: false,
  toggle: () => {},
  disableToggle: false,
})

export const useAccordionContext = () => useContext(AccordionContext)